"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DrawnByRender = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var DrawnByRender = exports.DrawnByRender = function DrawnByRender(_ref) {
  var draw = _ref.draw;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: draw()
  });
};